import React from 'react';

interface PageComponentMainHeaderProps {
  header: string;
  caption?: string;
}

export const PageComponentMainHeader = ({
  header,
  caption,
}: PageComponentMainHeaderProps) => {
  return (
    <>
      <h1 className="mb-2 font-title text-headingl text-text-default lg:text-headingxxl">
        {header}
      </h1>
      {caption && (
        <h2 className="font-title text-headings lg:text-headingm">{caption}</h2>
      )}
    </>
  );
};
